/**
 * @param RadioSelector Base widget for extending
 * @returns Core Radio Selector widget
 */
function RadioSelectorClassCreator(InputRadio: import('widgets/checkout/RadioSelector').TRadioSelector) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class RadioSelector
     * @augments InputRadio
     * @classdesc Radio selector component with next features:
     * 1. Rerenders selector by calling {@link RadioSelector#updateState} method from parent widget
     * 2. Creates focus on selected item by calling {@link RadioSelector#focusInput} method from parent widget
     * @example <caption>Example of radio selector for billing addresses</caption>
     * <div
     *     data-widget="radioSelector"
     *     data-id="billingAddressSelector"
     *  >
     *     <isloop items=${addresses} var="address">
     *         <div>
     *             <input
     *                 id="billing-${address.addressUUID}"
     *                 value="${address.addressUUID}"
     *                 type="radio"
     *                 name="savedAddress"
     *                 data-id="savedAddress-${address.addressUUID}"
     *                 data-ref="field"
     *                 data-value="${address.addressUUID}"
     *                 data-event-change="update"
     *                 <isif condition="${address.selected}">checked</isif>
     *                 data-first-name="${address.firstName}"
     *                 ...
     *             />
     *                 ...
     *                 <button
     *                     type="button"
     *                     data-event-click.prevent="updateAddress"
     *                     aria-describedby="billing-address-details-${address.addressUUID}"
     *                     data-uuid="${address.addressUUID}"
     *                 >
     *                     ${Resource.msg('button.edit', 'checkout', null)}
     *                 </button>
     *         </div>
     *     </isloop>
     * </div>
     */
    class RadioSelector extends InputRadio {
        loadMore(): void {
            Object.keys(this.refs).forEach((key: string) => {
                if (key.indexOf('hidden-option') !== -1) {
                    this.refs[key].show();
                }
            });

            this.ref('loadMoreButton').hide();
            this.emit('loadmore');
        }
    }

    return RadioSelector;
}

export type TRadioSelector = ReturnType<typeof RadioSelectorClassCreator>;

export type TRadioSelectorInstance = InstanceType<TRadioSelector>;

export default RadioSelectorClassCreator;
